import { render, staticRenderFns } from "./StageSidebar2.vue?vue&type=template&id=9c6c4efa"
import script from "./StageSidebar2.vue?vue&type=script&lang=js"
export * from "./StageSidebar2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports